import Button from "../button/button.component";
import { Link, useNavigate } from "react-router-dom";
import AddFunds from "../../components/addFunds/addFunds.component";
import { useEffect, useState, useContext } from "react";
import { getWalletBalance } from "../../Services/prod/auth.service";
import { useFormikContext, useField } from "formik";
import { getAuctionDefaultValues } from "../../Services/auction.service";
import UserVerifi from "../user-verification/user-verification.component";
import LoadingChild from "../loading-child/loading-child.component";
import { MoneyFormatted } from "../portfolio/portfolio-metrics/portfolio-metrics.component";
import arrowUpdate from '../../icons/arrow-update.png';
import { TransactionContend } from "./funds-menu.component.styles";
import GoToVerify from "../gotoverify/GoToVerify";


const FundsMenuDesktop = () => {
    const [balance, setBalance] = useState("");
    const [status, setStatus] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [kycLimit,setKycLimit] = useState(0);
    const [verificarionOpen,setVerificarionOpen] = useState(false);
    const [isPayment, setisPayment]=useState(false)
    const [goToVerify,setGoToVerify] = useState(false);
    const [handleOpen,setHandleOpen] = useState(false);

    useEffect(() => {
        try {
            getAuctionDefaultValues().then(data => {
        if (data) {
          setKycLimit(data.KYCLimit);
        }
      }) 
        } catch (error) {
           console.log(error) 
        }
    }, []);

    const handleMouseEnter = () => {
        getBalanceUpdate();
    };

    const getBalance = async () => {
        setLoading(true); 
        try {
            const walletRes = await getWalletBalance();
            const newBalance = walletRes?.data;
            setBalance(newBalance);
        } catch (error) {
            console.error("Error fetching balance:", error);
        } finally {
            setLoading(false); 
        }
    };

    const getBalanceUpdate = async () => {
        try {
            const walletRes = await getWalletBalance();
            const newBalance = walletRes?.data;
            setBalance(newBalance);
        } catch (error) {
            console.error("Error fetching balance:", error);
        }
    };
    
    useEffect(() => {
        getBalance();
    }, []);
      
    if (error) {
        return <div>Error: {error}</div>;
    }

    // OPEN MODAL
    function openModal(status) {
        setStatus(status);
        setModalOpen(true);
    }

    const handleButtonClick = () => {
        setLoading(true);
        getBalance();
    };

    return (
        <div onMouseEnter={handleMouseEnter}>
            <div className="content">
                <h3>My Funds</h3>
                <Button
                    onClick={() => openModal("Add")}
                    color="blue"
                >Add funds</Button>
            </div>
            {loading ? (
                <LoadingChild />
            ) : (
                <div className="content-around">
                    <div style={{ textAlign: "center", flexBasis: "45%" }} className="dotted-border">

                        <h4>Cash</h4>
                      
                        {balance?.length > 0 ? (
                                balance?.map((data, index) => (
                                    <>
                                        <div key={index}>
                                            <span style={{ display: "flex", justifyContent: "center" }}>
                                                {MoneyFormatted(data?.available_cash)}
                                                <TransactionContend className="transaction-button" onClick={handleButtonClick}>
                                                    <img src={arrowUpdate} />
                                                </TransactionContend>

                                            </span>
                                        </div>

                                    </>
                                ))
                            ) : (
                                <>
                                    <div>$0.00</div>
                                    <TransactionContend className="transaction-button" onClick={handleButtonClick}>
                                        <img src={arrowUpdate} />
                                    </TransactionContend>
                                </>
                                )}
                    </div>
                    <div style={{ textAlign: "center", flexBasis: "45%" }} className="dotted-border">
                        <h4>Restricted Cash</h4>
                        {balance?.length > 0 ? (
                            balance?.map((data, index) => (
                                <div key={index}>
                                    <span>{MoneyFormatted(data?.restricted_cash)}</span>
                                </div>
                            ))
                        ) : (
                            <div>$0.00</div>
                        )}
                    </div>
                </div>

            )}

            

            <Link className="link" to={"/billing-history"}>Transaction History</Link>
            {/*
            <AddFunds
                open={open}
                formProps={formProps}
                handleNext={onClickHandler}
                handleClose={handleClose}
            />*/}
            {verificarionOpen &&
             <UserVerifi setVerificarionOpen={setVerificarionOpen}/>
            }
        {modalOpen && 
                <AddFunds success={false} handleOpen={modalOpen} setHandleOpen={setModalOpen} setGoToVerify={setGoToVerify} status={status} setVerificarionOpen={setVerificarionOpen} setPayment={setisPayment} />
            }

        {goToVerify &&
            <GoToVerify goToVerify={goToVerify} setAddFunds={setHandleOpen} setGoToVerify={setGoToVerify} setVerificarionOpen={setVerificarionOpen} />
        }
        </div>
    )
}

export default FundsMenuDesktop;


export const InputMoneyField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  const handleChange = (event) => {
    const { value } = event.target;

    const strippedValue = value.replace(/[^\d.]/g, '');

    const num = parseFloat(strippedValue);
    const formattedValue = num.toLocaleString('en-US');

    setFieldValue(field.name, strippedValue === '' ? '' : formattedValue);

    event.target.value = formattedValue;
  };

  return (
    <input
      {...field}
      {...props}
      type="text"
      onChange={handleChange}
    />
  );
};
  